import React from 'react';
import { createRoot } from 'react-dom/client';

// jQuery is available globally in the application
declare const $: any;

interface CustomCloseButtonProps {
	onClick: () => void;
}

const CustomCloseButton: React.FC<CustomCloseButtonProps> = ({ onClick }) => (
	<button
		className="custom-button"
		id="custom-asap-close-btn"
		style={{ color: 'white', backgroundColor: 'transparent', border: 'none' }}
		title="Close"
		onClick={onClick}
	>
		<svg className="zd-asap-modulepopup-close__icon zd_asap_svg custom_icon_close1 zd-asap-newicon-size20" fill="currentColor">
			<use href="#close1" />
		</svg>
	</button>
);

let outsideClickHandler = null;

// The Zoho ASAP script is deferred, so its widget is not in the DOM when the nav
// first renders. Used to keep the Help Center control disabled until then.
export const isChatSupportReady = () => Boolean(
	document.getElementById('zohoasap_root') &&
    document.getElementById('zohohc-asap-web-button'),
);

const removeOutsideClickListener = () => {
	if (outsideClickHandler) {
		document.removeEventListener('mousedown', outsideClickHandler);
		outsideClickHandler = null;
	}
};

const closeWidget = (el, toggleButton) => {
	removeOutsideClickListener();
	el.style.animation = 'slideOutToRight 0.5s ease-in';
	el.style.animationFillMode = 'forwards';

	el.addEventListener('animationend', function onHide() {
		el.style.display = 'none';
		toggleButton.click();
		el.removeEventListener('animationend', onHide);
	}, { once: true });
};

const attachOutsideClickListener = (el, toggleButton) => {
	removeOutsideClickListener();

	outsideClickHandler = (event) => {
		if (
			!el.contains(event.target) &&
            !toggleButton.contains(event.target) &&
            !event.target.closest('#zoho-chat-icon')
		) {
			closeWidget(el, toggleButton);
		}
	};

	// mousedown rather than click: the mousedown that opens the widget has
	// already fired and bubbled by the time this listener is attached
	// (attached from the resulting click), so it can't immediately close
	// the widget it just opened.
	document.addEventListener('mousedown', outsideClickHandler);
};

export const handleChatSupport = () => {
	const el = document.getElementById('zohoasap_root');
	const toggleButton = document.getElementById('zohohc-asap-web-button');

	if (!el || !toggleButton) {
		console.warn('Support widget or toggle button not found.');
		return;
	}

	const isVisible = window.getComputedStyle(el).display === 'block';

	if (isVisible) {
		// Already visible, so we want to hide it
		closeWidget(el, toggleButton);
		return;
	}

	el.style.animation = 'none';
	el.style.display = 'none';

	(toggleButton as HTMLElement).click();

	const height = ($('#zohohc-asap-web-button') as any).outerHeight() + 35;
	const $parent = $('.zd-asap-header-logo__menu');

	// Create React component for custom close button

	if ($parent.length > 0 && $('#custom-asap-close-btn').length === 0) {
		// Create a container for the React component
		const buttonContainer = document.createElement('div');
		buttonContainer.id = 'custom-asap-close-btn-container';
		$parent.append(buttonContainer);

		// Render the React component
		const root = createRoot(buttonContainer);
		root.render(
			<CustomCloseButton onClick={() => closeWidget(el, toggleButton)} />,
		);
	}

	$('.zd-asap-header-logo__modulename').css('display', 'none');
	void el.offsetWidth;
	el.style.display = 'block';
	el.style.animation = 'slideInFromRight 0.5s ease-out';
	el.style.marginBottom = `${-height}px`;
	el.style.padding = '10px';

	attachOutsideClickListener(el, toggleButton);
};
